// extracted by mini-css-extract-plugin
export default {"toggle":"_3Lanq","tooltip":"sxlSN","badge-icon":"_2FT03","badgeIcon":"_2FT03"};